import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @atlaskit
import Avatar from '@atlaskit/avatar';
import Modal from '@atlaskit/modal-dialog';
import Tag from '@atlaskit/tag';

// @source
import { Messages } from '../../../../components';
import { User as API } from '../../../../../server';

const initialState = {
  isLoading: false,
  message: false,
};

class DeleteMultipleUsers extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.unmount = false;
    this.onSubmitHandle = this.onSubmitHandle.bind(this);
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onSubmitHandle(event) {
    event.preventDefault();

    this.setState({
      isLoading: true,
      message: false,
    });

    API.remove({
      data: this.props.users.map(item => ({ username: item })),
      dispatch: this.props.dispatch,
      success: () => {
        this.props.onClose(true);
      },
      error: (messages) => {
        this.setStateUnmount({
          isLoading: false,
          message: (
            <Messages
              component="Modal"
              items={messages}
              onClose={() => this.setState({ message: false })}
            />
          ),
        });
      },
    });
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  render() {
    return (
      <Modal
        appearance="warning"
        heading="Delete accounts"
        onClose={this.props.onClose}
        width="small"
        actions={[{
          text: 'Delete users',
          appearance: 'primary',
          isLoading: this.state.isLoading,
          onClick: this.onSubmitHandle,
        }, {
          text: 'Cancel',
          appearance: 'subtle',
          onClick: this.props.onClose,
        }]}
      >
        <div style={{ paddingLeft: 35 }}>
          <p>Are you sure you want to delete this accounts?</p>
          <div style={{ margin: '12px -4px 0' }}>
            {this.props.users.map(item => (
              <Tag
                color="greyTag"
                elemBefore={<Avatar size="xsmall" />}
                key={item}
                text={item}
              />
            ))}
            {this.state.message}
          </div>
        </div>
      </Modal>
    );
  }
}

DeleteMultipleUsers.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default connect()(DeleteMultipleUsers);
